// File: src/components/social/PostCard/PostCard.tsx
// Purpose: Social interaction component (comments, likes, shares)

import React from "react";
import styled from "styled-components";
import { LikeButton } from "../LikeButton/LikeButton";
import { ShareButton } from "../ShareButton/ShareButton";

interface PostCardProps {
  avatar: string;
  username: string;
  timeAgo: string;
  content: string;
  liked?: boolean;
  onLike: () => void;
  onShare: () => void;
}

const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.radii.md};
  box-shadow: ${({ theme }) => theme.elevations.low};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

const NameTime = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.p`
  margin-top: ${({ theme }) => theme.spacing.sm};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const PostCard: React.FC<PostCardProps> = ({
  avatar,
  username,
  timeAgo,
  content,
  liked,
  onLike,
  onShare,
}) => {
  return (
    <Card>
      <Header>
        <Avatar src={avatar} alt={`${username}'s avatar`} />
        <NameTime>
          <strong>{username}</strong>
          <small>{timeAgo}</small>
        </NameTime>
      </Header>
      <Content>{content}</Content>
      <Actions>
        <LikeButton liked={liked} onToggle={onLike} />
        <ShareButton onClick={onShare} />
      </Actions>
    </Card>
  );
};